
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import Translatable from '../../../../../../components/Translatable';

import styles from './styles.js';

const PanelFooter = ({ handleButtonClick }) => {
    return (
        <div className={css(styles.container)}>
            <button
                aria-disabled="false"
                type="button"
                className={css(styles.button)}
                onClick={handleButtonClick}
            >
                <span>
                    <Translatable
                        content={{
                            transKey: 'search.see_spaces'
                        }}
                    />
                </span>
            </button>
        </div>
    );
};

PanelFooter.propTypes = {
    handleButtonClick: PropTypes.func.isRequired
};

export default PanelFooter;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelSmallScreen/PanelFooter/PanelFooter.jsx